<template>
  <div
    v-click-outside="handleClickOutside"
    class="dropdown"
    :class="{ 'dropdown--active': showDropDown }"
    @click="clickDropDown"
  >
    <p>{{ currentOption || defaultOption }}</p>
    <ul
      v-show="showDropDown"
      class="dropdown__options"
    >
      <li
        v-for="(option, index) in options"
        :key="index"
        @click="clickOption(option)"
      >
        {{ option }}
      </li>
    </ul>
    <svg
      class="dropdown__image"
      :class="{ 'dropdown__image-rotate': showDropDown }"
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
    >
      <path
        d="M14.0925 1.5456L7.54688 8.0912L1.00127 1.5456"
        stroke="#969698"
        stroke-width="2"
        stroke-linecap="round"
      />
    </svg>
  </div>
</template>

<script lang="ts">
  import { vOnClickOutside } from '@vueuse/components';

  export default defineNuxtComponent({
    name: 'BaseDropDown',

    directives: {
      clickOutside: vOnClickOutside,
    },

    props: {
      options: {
        type: Array,
        required: true,
      },
      defaultOption: {
        type: String,
        required: true,
      },
    },

    data() {
      return {
        showDropDown: false,
        currentOption: '',
      };
    },

    methods: {
      clickDropDown() {
        this.showDropDown = !this.showDropDown;
      },
      clickOption(option: string) {
        this.currentOption = option;
        this.$emit('changeOption', option);
      },
      handleClickOutside() {
        this.showDropDown = false;
      },
    },
  });
</script>

<style lang="scss" scoped>
  @use '@devhacker/shared/styles/scrollbar.scss' as scrollbar;

  .dropdown {
    height: 48px;
    width: 100%;
    border: 1px solid $borderColor;
    border-radius: 4px;
    background: #fff;
    padding: 12px 16px;
    font-family: $mainFont;
    font-weight: 400;
    line-height: 24px;
    position: relative;
    &--active {
      border: 1px solid #2962f9;
    }
    @include hover {
      cursor: pointer;
      border: 1px solid #2962f9;
    }
    &__options {
      height: 250px;
      overflow-y: scroll;
      background-color: #fff;
      position: absolute;
      z-index: 1;
      top: 54px;
      left: 0;
      width: 100%;
      box-shadow: 0px 3px 10px 0px #00000040;

      @include scrollbar.customScrollbar;

      li {
        padding: 12px 16px;

        @include hover {
          background: #f3f5fc;
        }
        &::before {
          content: none;
        }
      }
    }
    &__image {
      position: absolute;
      height: 10px;
      width: 15px;
      right: 16px;
      top: 20px;
      transition: transform 0.5s;
      transform: rotate(0deg);
      &-rotate {
        transform: rotate(180deg);
      }
    }
  }
</style>
